export default {
  scheduledManager: {
    title: "Scheduled Readvertisement Manager",
    moreActions: {
      label: {
        full: "More actions",
        short: "More",
      },
      option: {
        delete: "Delete",
        copy: "Copy",
      },
      dropdown: {
        title: "More",
      },
    },
    bulkAction: {
      buttons: {
        copy: "Copy",
        delete: "Delete",
        cancel: "Cancel",
      },
      selected: "<strong>{count}</strong> selected",
      left: "<strong>{count}</strong> Left",
      delete: {
        title: "Confirm delete",
        content: "Are you sure you want to delete scheduled readvertisement?",
        confirm: "Yes, delete",
        success: "Scheduled readvertisements have been deleted.",
      },
      copy: {
        success:
          "{count} listing{count, plural, =0 {} =1 {} other{s}} are now readvertised.",
      },
    },
    tabs: {
      queue: "Queued",
      success: "Successful",
      fail: "Failed",
      cancel: "Cancelled",
    },
    selectAll: "Select all",
    expandedListing: {
      detailsInfo: {
        price: "Price: <strong>RM{value}</strong>",
        id: "ID: <strong>{value}</strong>",
        type: "Property type: <strong>{value}</strong>",
        tier: "Tier: <strong>{value}</strong>",
      },
      actions: {
        show: "Show full schedule ",
      },
    },
    expandedModal: {
      title: "Showing schedule for:",
    },
    modal: {
      tip: {
        upgrade: {
          title: "Listing could not be upgraded",
          content:
            "Since this listing is scheduled to readvertise, it cannot be upgraded.",
        },
        downgrade: {
          title: "Listing could not be downgraded",
          content:
            "Since this listing is scheduled to readvertise, it cannot be downgraded.",
        },
        offline: {
          title: "Listing could not be taken offline",
          content:
            "Since this listing is scheduled to readvertise, it cannot be taken offline.",
        },
      },
      buttons: {
        ok: "OK",
      },
    },
  },
};
